import { BasicCommand } from "./BasicCommand";


import { BasicSmartfoxConstants } from "../BasicSmartfoxConstants";
import { BasicErrorConstants } from "./constants/BasicErrorConstants";
import { BasicModel } from "../../model/BasicModel";
import { debug } from "../../../logging/debug";

/**
 * Command activates configurations depending on the current server instance.
 * Documentation see here:
 * https://sites.google.com/a/goodgamestudios.com/tech-wiki/java/events/serverinfoevent
 */
export class NFOCommand extends BasicCommand {

    protected get cmdId(): string {
        return BasicSmartfoxConstants.S2C_SERVER_INFO_EVENT;
    }

    public executeCommand(error: number, params: any[]): boolean {
        if (error == BasicErrorConstants.ALL_OK) {
            let paramsObj: any = JSON.parse(params[1]);

            // Set minimum username length needed for registration.
            // In certain asian countries like japan or korea there are usernames possible that consist of a single character.
            // See jira issue #FLC-358
            BasicModel.basicLocalization.setUsernameMinLength = paramsObj.minNameSize;

            // Compare item xml versions
            let itemsVersionServer: string = paramsObj.itemXmlVersion;

            this.compareItemsVersions(itemsVersionServer);

            return true;
        }

        return false;
    }

    private compareItemsVersions(itemsVersionServer: string): void {
        let itemsVersionClient: string = this.env.versionInformation.itemXmlVersion;
        if (itemsVersionClient != itemsVersionServer) {
            debug("Item XML version of client [" + itemsVersionClient + "] doesn't fit to item XML version of the server [" + itemsVersionServer + "]");
        }
    }
}
